export const FORM_QUESTIONNAIRE_OPENED = 'FORM_QUESTIONNAIRE_OPENED';

export function formQuestionnaireOpened(formId, formType) {
  return dispatch => dispatch({
    formId,
    formType,
    type: FORM_QUESTIONNAIRE_OPENED,
  });
}
